import React from 'react'
import { useNavigate } from 'react-router-dom';
import img from "../../../images/asset.png"
import admin from "../../../images/admin.png"
import ViewportMeta from '../../../utils/ViewportMeta';
import { useTranslation } from 'react-i18next';
import Sidebarfats from '../../../components/sidebar/Sidebarfats';

const CustodianDetails = () => {
const { t, i18n } = useTranslation()

  const navigate = useNavigate();
  return (
    <>
      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
          <ViewportMeta />
          <div className={`z-10 before:animate-pulse my-7 smm:my-10 before:bg-gradient-to-b before:from-gray-900 overflow-hidden before:via-[#00FF00] before:to-gray-900 ${i18n.language === 'ar' ? '2xl:ml-60 smm:mr-0' : '2xl:ml-60 smm:ml-0'}`}>
            <div className={`w-full h-auto px-3 sm:px-5 flex`}>
              <div
                className={`w-full sm:w-1/2 lg:w-[900px] px-6 bg-gray-500 bg-opacity-20 bg-clip-padding backdrop-filter backdrop-blur-sm text-white z-10 py-4  rounded-lg ${i18n.language === "ar" ? "direction-rtl" : "direction-ltr"
                  }`}
              >  <div className="w-full flex justify-center font-semibold p-6 shadow-xl text-black text-xl mb:2 md:mb-5">
                  {t("Asset Custodian Details")}
                </div>
                <form>
                  <div className="mb-6">
                    <label htmlFor="locationtag" className="block mb-2 text-xs font-medium text-black">{t("Location Tag")}</label>
                    <input
                      placeholder={t('Location Tag')}
                      id="locationtag"
                      value="Majid"
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                  </div>

                  <div className="mb-6">
                    <label htmlFor="tag" className="block mb-2 text-xs font-medium text-black">{t("TAG")}*</label>
                    <input
                      id='tag'
                      placeholder={t('Tag')}
                      value="0044583825962"
                      readOnly
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>

                  <div className="mb-6">
                    <label htmlFor="assetlocationtag" className="block mb-2 text-xs font-medium text-black">{t("Asset Location Details")}*</label>
                    <textarea
                      id="assetlocationtag"
                      readOnly
                      value="hello"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block h-28 w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder={t("Asset Location Details")}
                      required
                    />
                  </div >

                  <div className="mb-6">
                    <label htmlFor="department" className="block mb-2 text-xs font-medium text-black">{t("Serial No")}.</label>
                    <input
                      id='department'
                      readOnly
                      value="23432"
                      placeholder={t('Serial No')}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                  </div>

                  <div className='flex justify-center items-center gap-2'>
                    <div className='flex flex-col flex-wrap mb-6 w-[50%]'>
                      <label htmlFor="emp" className="block mb-2 text-xs font-medium text-black">{t("EMPLOAYEE ID")}*</label>
                      <input
                        id="emp"
                        readOnly
                        value="2000"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("EMPLOAYEE ID")} />
                    </div>

                    <div className='flex flex-col flex-wrap mb-6 w-[50%]'>
                      <label htmlFor="phone" className="block mb-2 text-xs font-medium text-black">{t("Phone No")}.</label>
                      <input
                        id="phone"
                        readOnly
                        value="44321543"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Phone Number")} />
                    </div>
                  </div>

                  <div className="mb-6">
                    <label htmlFor="Business" className="block mb-2 text-xs font-medium text-black">{t("Name")}</label>
                    <input
                      id="Business"
                      readOnly
                      value="IT Depart"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={t("Business Name")} />
                  </div>

                  <div className="mb-6">
                    <label htmlFor="other" className="block mb-2 text-xs font-medium text-black">{t('Other Tag')}</label>
                    <input
                      id="other"
                      readOnly
                      value=""
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                  </div>

                  <div className="mb-6">
                    <label htmlFor="notes" className="block mb-2 text-xs font-medium text-black">{t("Notes")}</label>
                    <input
                      readOnly
                      value=""
                      id="notes"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                  </div>

                  <div className='flex justify-center items-center gap-3 mb-6 w-full'>
                    <img
                      src={img}
                      className='h-14 w-14 mt-5 cursor-pointer'
                      alt=''
                    />
                    <img
                      src={admin}
                      className='h-14 w-14 mt-5 cursor-pointer'
                      alt=''
                    />
                    <input
                      id='fileInput'
                      type='file'
                      style={{ display: 'none' }}
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      multiple
                    />
                  </div>

                  <div className="mb-6">
                    <label htmlFor="assetcondition" className="block mb-2 text-xs font-medium text-black">{t("Asset Condition")}</label>
                    <input
                      readOnly
                      value="Fair"
                      id="assetcondition"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>

                  <div className="mb-6">
                    <label htmlFor="bought" className="block mb-2 text-xs font-medium text-black">{t("Bought")}</label>
                    <input
                      id='bought'
                      readOnly
                      value="Bought"
                      placeholder={t('Bought')}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-xs font-semibold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                  </div>

                  <div className="mt-4 md:mt-10 flex justify-between w-full text-sm md:text-xl py-2 rounded-md">

                    <button onClick={() => navigate(-1)} type='submit' className="bg-[#00006B] text-white font-bold py-3 px-10 rounded-l">
                      {t("Back")}
                    </button>

                  </div>
                </form >
              </div >
            </div >
          </div >
        </div>
    </>
  )
}

export default CustodianDetails